// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireInformationActions = require('actions/hireInformation');
const openYoungTutorTypeActions = require('actions/openYoungTutorType');
const openYoungPersonalDataActions = require('actions/openYoungPersonalData');
const openYoungTaxDataActions = require('actions/openYoungTaxData');
const openYoungProfileDetailsActions = require('actions/openYoungProfileDetails');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { APIPost } = require('utilities/APIRequestHelper');
const { APIGet } = require('utilities/APIRequestHelper');
const { formatDate } = require('utilities/dateHelper');
const { getGender } = require('routes/contractsView/utilities/formHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const {
  getCardStandard,
  getDebitCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
const get = require('lodash/object/get');

// @ constants
const actionTypes = require('constants/actionTypes');
const { MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');

const {
  DATE_FORMAT_API,
  DEFAULT_COUNTRY,
  FOURTH_STEP,
  OPENYOUNG_CARD_SUBTYPE,
  OPENYOUNG_CARD_TYPE,
  THIRD_STEP,
  FIRST_STEP,
} = require('constants/index');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { OPEN_YOUNG_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');

const resetWizard = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_RESET,
});

const setAssociatedAccount = accountId => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_ASSOCIATED_ACCOUNT,
  payload: {
    accountId,
  },
});

const setAgreementCheckbox = evt => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_AGREEMENT_CHECKBOX,
  payload: {
    checked: evt.target.checked,
  },
});

const selectAccount = accountId => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_ACCOUNT,
  payload: {
    accountId,
  },
});

const setExistingOpenyoung = (immOpenYoungProfileDetails, mobileNumber) => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_EXISTING_OPENYOUNG,
  payload: {
    immOpenYoungProfileDetails,
    mobileNumber,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setVisibleStep = step => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SET_VISIBLE_STEP,
  payload: {
    step,
  },
});

const setWillCancel = willCancel => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_WILL_CANCEL,
  payload: {
    willCancel,
  },
});

const toggleTutorCheckbox = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_TOGGLE_TUTOR_CHECKBOX,
});

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

const validate = (step, externalComponentsAreValid) => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_VALIDATE_STEP,
  payload: {
    step,
    valid: externalComponentsAreValid,
  },
});

const validateAccount = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_VALIDATE_ACCOUNT,
});

const getValidCurrentCardImages = response => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_AVAILABLE_CARD_IMAGES,
  payload: response,
});

const hireCardOpenYoungFailure = response => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_FAILURE,
  payload: response,
});

const hireCardOpenYoungRequest = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_REQUEST,
});

const hireCardOpenYoungSuccess = response => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_SUCCESS,
  payload: {
    response,
  },
});

const addAccount = () => ({
  type: actionTypes.HIRE_CARD_OPEN_YOUNG_ADD_ACCOUNT,
});

const selectExistingOpenyoung = accountId => (dispatch, getState) => {
  dispatch(selectAccount(accountId));
  dispatch(openYoungProfileDetailsActions.getOpenYoungProfileDetails(accountId)).then(() => {
    const immOpenYoungProfileDetails = getState().openYoungProfileDetails;
    const mobileNumber = PersonalDataHelper.getPhoneOnly(getState().profile);
    dispatch(setExistingOpenyoung(immOpenYoungProfileDetails, mobileNumber));
    const immBeneficiaryAccount = getState().hireCardOpenYoung.getIn([
      'steps',
      THIRD_STEP,
      'juniorAccount',
    ]);
    const immBeneficiaryAccountOC = immBeneficiaryAccount.merge({
      originCountry: immOpenYoungProfileDetails.get('originCountry'),
    });
    dispatch(
      hireContactDataActions.fillOpenYoungProfile(
        immBeneficiaryAccountOC,
        'hireCardOpenYoungContact'
      )
    );
    dispatch(openYoungPersonalDataActions.fillOpenYoungPersonalData(immBeneficiaryAccount));
  });
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardOpenYoung.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const reset = () => dispatch => {
  dispatch(hireInformationActions.reset());
  dispatch(openYoungTutorTypeActions.reset());
  dispatch(openYoungPersonalDataActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHireCardOpenYoung = getState().hireCardOpenYoung;
  const immStep3 = immHireCardOpenYoung.getIn(['steps', THIRD_STEP]);
  const immOpenYoungTutorType = getState().openYoungTutorType;
  const immOpenYoungPersonalData = getState().openYoungPersonalData;
  const immOpenYoungTaxData = getState().openYoungTaxData;
  const immHireContactData = getState().hireContactData;
  const immContactDetails = immHireContactData.getIn([
    'extraInstances',
    'hireCardOpenYoungContact',
  ]);
  let allComponentsAreValid = false;

  if (immStep3.getIn(['tutorCheckbox', 'isValid'])) {
    allComponentsAreValid =
      immOpenYoungTutorType.get('isValid') &&
      immOpenYoungPersonalData.get('isValid') &&
      immContactDetails.get('isValid') &&
      immOpenYoungTaxData.get('isValid');
  }

  dispatch(validate(step, allComponentsAreValid));
};

const validateFourthStep = step => (dispatch, getState) => {
  const accountIsValid = getState().hireCardOpenYoung.getIn([
    'steps',
    FOURTH_STEP,
    'accountIsValid',
  ]);

  dispatch(validate(step, accountIsValid));
};

const validateFifthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');

  let allComponentsAreValid = true;
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));

    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const getAvailableHiringCardsImages = (dispatch, getState) => {

  return APIGet({
    dispatch,
    endpoint: 'available',
    params: { query: { product: '506', subproduct: '010' } },
  })
    .then(response => {
      dispatch(getValidCurrentCardImages(response));
    })
    .catch(error => {});
};

const validateStep = step => (dispatch, getState) => {
  if (step === 2) {
    dispatch(hireCardImageSelectorActions.validateStep());
    dispatch(validateSecondStep(step));
  } else if (step === 3) {
    dispatch(openYoungTutorTypeActions.validateStep());
    dispatch(openYoungPersonalDataActions.validateStep());
    dispatch(hireContactDataActions.validateStep(true, 'hireCardOpenYoungContact'));
    dispatch(openYoungTaxDataActions.validateStep());
    dispatch(validateThirdStep(step));
  } else if (step === 4) {
    dispatch(validateAccount());
    dispatch(validateFourthStep(step));
  } else if (step === 5) {
    //FIFTH_STEP
    dispatch(validateFifthStep(step));
  } else if (step === 1 && getState().flagBasedFeatures.get(MESSAGE_HIRE_24H)) {
    getAvailableHiringCardsImages(dispatch, getState);
    const immHireCardOpenYoung = getState().hireCardOpenYoung;
    const immStep1 = immHireCardOpenYoung.getIn(['steps', FIRST_STEP]);
if(typeof immStep1.get('agreementChecked') === 'boolean' && immStep1.get('agreementChecked') === false){
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    else {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');
      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardOpenYoungFailure(''));
              dispatch(validateLoading(false));
            }
          }
        });
    }
  } else {
    dispatch(validateLoading(false));
    dispatch(validate(step, false));
  }
  return dispatch(getStep(step));
};

const setOpenYoung = (dispatch, data, termsAndsCondsHiringData) => {
  const requestData = {
    query: data,
    header: {
      version: 3,
    },
  };

  dispatch(hireCardOpenYoungRequest());
  return APIPost({
    dispatch,
    endpoint: 'openYoungHire',
    params: requestData,
  })
    .then(response => {
      const status = getDebitCardHiringStatus(response);

      if (get(response, 'result.msg', '') === 'OK' || !status.error) {
        dispatch(hireCardOpenYoungSuccess(response));
        dispatch(setTermsAndCondsInfo(OPEN_YOUNG_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
      } else {
        dispatch(hireCardOpenYoungFailure({ error: status.errorMsg }));
      }
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(hireCardOpenYoungFailure(response.body));
      } else {
        throw response;
      }
    });
};

const hireCardOpenYoung = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardOpenYoung.getIn(['steps', FOURTH_STEP, 'accountId']);
    const juniorAccountId = getState().hireCardOpenYoung.getIn([
      'steps',
      THIRD_STEP,
      'juniorAccountId',
    ]);
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const immPersonalData = getState().openYoungPersonalData;
    const immHireContactData = getState().hireContactData;
    const immContactDetails = immHireContactData.getIn([
      'extraInstances',
      'hireCardOpenYoungContact',
    ]);
    let personCode = 0;
    let personType = '';

    if (juniorAccountId !== '') {
      const immJuniorAccount = getState().openYoungProfiles.getIn(['byId', juniorAccountId]);

      personCode = immJuniorAccount.get('personCode');
      personType = immJuniorAccount.get('personType');
    }

    const postalCode = immContactDetails.getIn(['postalCode', 'value']);
    const street = immContactDetails.getIn(['roadName', 'value']);
    const number = immContactDetails.getIn(['number', 'value']);
    const floor = immContactDetails.getIn(['others', 'value']);
    const town = immContactDetails.getIn(['population', 'value']);
    const province = immContactDetails.getIn(['province', 'value']);
    const phoneNumber = immContactDetails.getIn(['mobile', 'value']);
    const streetType = immContactDetails.getIn(['roadType', 'value']);

    const personalLastName = immPersonalData.getIn(['lastName', 'value']);
    const personalLastName2 = immPersonalData.getIn(['lastName2', 'value']);
    const personalDocumentNumber = immPersonalData.getIn(['documentNumber', 'value']);
    const personalBirthDate = formatDate(
      immPersonalData.getIn(['birthDate', 'value']),
      DATE_FORMAT_API
    );
    const personalGender = getGender(immPersonalData.getIn(['gender', 'value']));
    const personalNationality = immPersonalData.getIn(['nationality', 'value']);
    const personalName = immPersonalData.getIn(['name', 'value']);
    const personalCountry = immPersonalData.getIn(['country', 'value']);
    const personalPopulation = immPersonalData.getIn(['population', 'value']);
    const personalProvince = immPersonalData.getIn(['province', 'value']);
    const personalDocumentType = immPersonalData.getIn(['documentType', 'value']);

    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));

    const accountContractNumber = immAccount.get('contractNumber');
    const accountProduct = immAccount.get('product');

    const tutorType = getState().openYoungTutorType.get('value');

    //shipping address details
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    let shippingAddressDetail = null;
    let numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      shippingAddressDetail = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      cardDesignKey: cardDesignKey,
      datosContactoBeneficiario: {
        codigoPostal: postalCode,
        nombreVia: street,
        numero: number,
        piso: floor,
        poblacion: town,
        provincia: province,
        telefonoMovil: phoneNumber,
        tipoVia: streetType,
      },
      datosTitular: {
        apellido1: personalLastName,
        apellido2: personalLastName2,
        documento: personalDocumentNumber,
        fechaNacimiento: personalBirthDate,
        genero: personalGender,
        nacionalidad: personalNationality,
        nombre: personalName,
        paisNacimiento: personalCountry,
        pobNacim: personalPopulation,
        relacion: tutorType,
        tipoDocumento: personalDocumentType,
      },
      personaMenor: {
        codigodepersona: personCode,
        tipodepersona: personType,
      },
      firmaToken: dataToken,
      numerodecontrato: accountContractNumber,
      producto: accountProduct,
      numDomicilio,
      deliverToProvidedDetails: true,
      shippingAddressDetail,
      //TODO: To be replace with actual data once get approved
      nombreAdicional: '',
      nombreBeneficiario: '',
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: OPENYOUNG_CARD_SUBTYPE,
        type: OPENYOUNG_CARD_TYPE,
      },
    ];

    if (personalCountry === DEFAULT_COUNTRY && !!personalProvince) {
      data.datosTitular.provNacim = personalProvince;
    }

    setOpenYoung(dispatch, data, termsAndsCondsHiringData);
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  addAccount,
  hireCardOpenYoung,
  reset,
  setAssociatedAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  selectExistingOpenyoung,
  setExistingOpenyoung,
  setVisibleStep,
  setWillCancel,
  toggleTutorCheckbox,
  validate,
  validateStep,
  getAvailableHiringCardsImages
};
